import {Findings} from '@github-ui/copilot-findings'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {Suspense} from 'react'
import {usePullRequestBasePath} from '../stores/layout-selectors'

export const FindingsEntrypoint = () => (
  <ErrorBoundary boundaryName="FindingsEntrypoint" fallback={null}>
    <Suspense fallback={null}>
      <FindingsContent />
    </Suspense>
  </ErrorBoundary>
)

const FindingsContent = () => {
  const basePath = usePullRequestBasePath()
  return <Findings pullRequestBasePath={basePath} variant="page" />
}
